import { Card, styled } from '@mui/material';
import { ReactNode } from 'react';

interface CarouselTileProps {
  id?: string | null | undefined;
  children: ReactNode;
  padding?: number;
}

export const CarouselTile = ({ id, children, padding = 24 }: CarouselTileProps) => {
  return (
    <StyledCard
      id={id ?? undefined}
      padding={padding}
      variant='outlined'
    >
      {children}
    </StyledCard>
  );
};

const StyledCard = styled(Card)<{ padding: number }>`
  ${({ padding }) => `padding: ${padding}px;`};
`;
